import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

export const useProjectByIdProjectsDashboard = () => {
    const { getDataAsync } = useApi();

    const { projectId } = useParams();

    const getProjectByIdApiCall = useCallback(async () => {
        if (projectId === undefined) {
            return undefined;
        } else {
            const response = await getDataAsync("getProjectById", {
                urlParams: [{ name: "$projectId", value: projectId }],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;
        }

    }, [getDataAsync, projectId]);

    const projectData = useQuery(
        "projectByIdData",
        () => getProjectByIdApiCall(),
        { refetchOnWindowFocus: false }
    );

    return useMemo(() => {
        return {
            projectData,
        };
    }, [projectData]);
};

const useProjectsDashboardOverviewBudget = () => {
    const { getDataAsync } = useApi();

    const { projectId } = useParams();

    const getBudgetSummaryApiCall = useCallback(
        async ({ endpointSuffix, startDate, endDate }) => {
            const response = await getDataAsync(
                "projectsDashboardBudgetSummary",
                {
                    urlParams: [
                        { name: "$endpointSuffix", value: endpointSuffix },
                        { name: "$projectId", value: projectId },
                        { name: "$startDate", value: startDate },
                        { name: "$endDate", value: endDate },
                    ],
                }
            );

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync, projectId]
    );

    return useMemo(() => {
        const useBudgetSummary = (dataObj) =>
            useQuery(
                [`budgetSummary${dataObj.endpointSuffix}`, dataObj],
                () => getBudgetSummaryApiCall(dataObj),
                { refetchOnWindowFocus: false }
            );

        return {
            useBudgetSummary,
        };
    }, [getBudgetSummaryApiCall]);
};

export default useProjectsDashboardOverviewBudget;

export const useProjectTimesheetSummaryData = () => {
    const { getDataAsync } = useApi();

    const { projectId } = useParams();

    const getProjectTimesheetSummaryApiCall = useCallback(async () => {
        if (projectId === undefined) {
            return undefined;
        } else {
            const response = await getDataAsync(
                "getProjectTimesheetSummaryData",
                {
                    urlParams: [{ name: "$projectId", value: projectId }],
                }
            );

            const result = response.status === 204
                ? null
                : response.json();

            return result;
        }
    }, [getDataAsync, projectId]);

    const projectTimesheetSummaryData = useQuery(
        "projectSummaryData",
        () => getProjectTimesheetSummaryApiCall(),
        { refetchOnWindowFocus: false }
    );

    return useMemo(() => {
        return {
            projectTimesheetSummaryData,
        };
    }, [projectTimesheetSummaryData]);
};
